import React from "react";
import { ClothesDetectionResult } from "../../../utilities/types/free-trial/auto-tagging-service/types";

interface VisualClothesResultDisplayProps {
  data: ClothesDetectionResult;
  uploadedImage?: string;
}

const VisualClothesResultDisplay: React.FC<VisualClothesResultDisplayProps> = ({ data, uploadedImage }) => {
  return (
    <div className="flex flex-col items-center w-full gap-8">
      <div className="flex flex-col items-center w-full max-w-4xl gap-6 md:items-start md:flex-row">
        {uploadedImage && (
          <div className="grid place-content-center w-[15rem] h-[25rem] border-2 rounded-md border-gorgonzola-blue-50 overflow-hidden flex-shrink-0">
            <img src={`data:image/png;base64,${uploadedImage}`} alt="Uploaded" className="object-contain w-[15rem] h-[25rem]" />
          </div>
        )}

        <div className="flex-1">
          {data?.Clothes.length ? (
            <div className="grid grid-cols-2 gap-4 p-4 border rounded-lg md:grid-cols-3 border-gorgonzola-blue-50">
              {data.Clothes.map((clothingItem, index) => (
                <div key={index} className="flex flex-col items-center gap-2 p-3 transition-colors border rounded-md border-gorgonzola-blue-50 hover:bg-gorgonzola-blue-50/30">
                  <div className="text-sm font-medium text-closed-shutter-300">
                    {clothingItem.ClotheType}
                    {clothingItem.Design && ` - ${clothingItem.Design}`}
                  </div>
                  {clothingItem.Sleeve && <div className="text-xs text-closed-shutter-300/70">Sleeve: {clothingItem.Sleeve}</div>}
                  {clothingItem.DressLength && <div className="text-xs text-closed-shutter-300/70">Length: {clothingItem.DressLength}</div>}
                </div>
              ))}
            </div>
          ) : (
            <div className="p-8 text-center">
              <p className="text-closed-shutter-300/70">No clothes detected</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VisualClothesResultDisplay;
